import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSubscription } from '@/contexts/SubscriptionContext';

// One-time, loop-safe redirect that sends a Firmenadmin whose company setup is
// not yet completed to the onboarding wizard (Phase C5). Mounted once at the
// router root; never redirects away from setup/auth routes.
const SKIP_PREFIXES = [
  '/einrichtung', '/onboarding', '/login', '/register', '/registrieren',
  '/einladung/annehmen', '/accept-invite', '/passwort', '/reset-password', '/forgot-password',
];

export const OnboardingRedirect = () => {
  const { role, loading } = useSubscription();
  const navigate = useNavigate();
  const location = useLocation();
  // Keyed on the login token so a fresh login (even in the same browser tab)
  // re-checks the onboarding status. The wizard keeps reappearing on every
  // login until the Firmenadmin has actually completed it once.
  const checkedToken = useRef(null);

  useEffect(() => {
    if (loading) return;
    if (role !== 'company_admin') return;
    if (SKIP_PREFIXES.some((p) => location.pathname.startsWith(p))) return;

    const token = localStorage.getItem('token');
    if (!token) return;
    if (checkedToken.current === token) return; // already checked this login session
    checkedToken.current = token;

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/team/onboarding`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d && !d.completed) navigate('/einrichtung');
      })
      .catch(() => {});
  }, [role, loading, location.pathname, navigate]);

  return null;
};
